const values = {
  1: "sm:columns-1",
  2: "sm:columns-2",
  3: "sm:columns-3",
};

export default function getColumnsSm(value) {
  return values[value];
}
